function useStyles() {
    return {
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'end',
            flexWrap: 'wrap'
        },
        title: {
            display: 'flex',
            flexDirection: 'column',
        },
        visits: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        up: {
            display: 'flex',
            alignItems: 'center'
        },
        space: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        }
    }
}

export { useStyles }